import { render, staticRenderFns } from "./GetGasButton.vue?vue&type=template&id=bc585266"
import script from "./GetGasButton.vue?vue&type=script&lang=ts"
export * from "./GetGasButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports